import _asyncToGenerator from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import HardwareWallet from '../helpers/hardware-wallet-class';
import Ledger from '../helpers/lib-ledger';
import ledgerLocalstorage from '../helpers/ledger-localstorage';
var LedgerWallet = /*#__PURE__*/function (_HardwareWallet) {
  _inherits(LedgerWallet, _HardwareWallet);
  var _super = _createSuper(LedgerWallet);
  // use ONE transport at the time!!!
  function LedgerWallet(validChainIds, bluetooth) {
    var _this;
    _classCallCheck(this, LedgerWallet);
    _this = _super.call(this, validChainIds);
    var instance = _assertThisInitialized(_this);
    var cbPropUpdate = instance._devicePropertyUpdate.bind(instance);
    var cbEvents = instance._ledgerEvents.bind(instance);
    instance.ledger = new Ledger(cbPropUpdate, cbEvents, bluetooth);
    instance.bluetooth = !!bluetooth;
    instance.hardwareStatus = instance.ledger.hardwareStatus;
    instance.localstorage = ledgerLocalstorage(instance.bluetooth ? 'ledgerwalletbt' : 'ledgerwallet');
    instance.name = bluetooth ? 'ledgerbt' : 'ledger';
    instance.devicename = instance.localstorage.get('devicename');
    instance.address = instance.localstorage.get('address');
    instance.accounts = instance.localstorage.get('accounts');
    if (instance.address) {
      instance.chainId = instance.localstorage.get('chainId');
    } else {
      // force to choose the network, which will lead into reading of the accounts
      instance.chainId = null;
    }
    instance.initializationPromise.fulfill();
    return _this;
  }

  // handles callbacks from the Ledger Device
  _createClass(LedgerWallet, [{
    key: "_devicePropertyUpdate",
    value: function _devicePropertyUpdate(prop, value) {
      var instance = this;
      if (instance.activated) {
        instance[prop] = value;
        instance.localstorage.set(prop, value);
        instance.forceUpdateContext();
      }
    }

    // handles events from the Ledger Hardware
  }, {
    key: "_ledgerEvents",
    value: function _ledgerEvents(message, level, needsToSign) {
      var instance = this;
      var type = instance.eventSeverities[level] || 'message';
      instance.emitter.emit(type, message, needsToSign);
    }
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.activated = true;
              this.ledger.active = true;
              return _context.abrupt("return", true);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.ledger.active = false;
      this.localstorage.clearAll();
      _get(_getPrototypeOf(LedgerWallet.prototype), "deactivate", this).call(this);
    }
  }, {
    key: "networkConnected",
    value: function networkConnected() {
      var instance = this;
      return instance.activated && !!instance.chainId && !!instance.address && (!instance._validChainIds || instance._validChainIds.includes(instance.chainId));
    }
  }, {
    key: "switchToNetwork",
    value: function () {
      var _switchToNetwork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(chainId) {
        var instance;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              instance = this;
              if (instance.activated) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              instance.chainId = chainId;
              instance.localstorage.set('chainId', chainId);
              instance.forceUpdateContext();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function switchToNetwork(_x) {
        return _switchToNetwork.apply(this, arguments);
      }
      return switchToNetwork;
    }()
  }, {
    key: "switchToAddress",
    value: function () {
      var _switchToAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address) {
        var instance;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              instance = this;
              if (instance.activated) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              instance.address = address;
              instance.localstorage.set('address', address);
              instance.forceUpdateContext();
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function switchToAddress(_x2) {
        return _switchToAddress.apply(this, arguments);
      }
      return switchToAddress;
    }()
  }, {
    key: "sendTx",
    value: function () {
      var _sendTx = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(rawTx, _ref) {
        var web3, extraPercentageGas, instance, accountIndex, tx;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              web3 = _ref.web3, extraPercentageGas = _ref.extraPercentageGas;
              instance = this;
              accountIndex = instance.accounts.indexOf(instance.address);
              _context4.prev = 3;
              _context4.next = 6;
              return instance.ledger.sendTx(rawTx, instance.address, accountIndex, instance.accounts[0], {
                web3: web3,
                extraPercentageGas: extraPercentageGas
              });
            case 6:
              tx = _context4.sent;
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](3);
              console.error(_context4.t0);
            case 12:
              return _context4.abrupt("return", tx);
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[3, 9]]);
      }));
      function sendTx(_x3, _x4) {
        return _sendTx.apply(this, arguments);
      }
      return sendTx;
    }()
  }, {
    key: "setSelectDeviceFn",
    value: function setSelectDeviceFn(selectDevice) {
      if (typeof selectDevice === 'function') {
        this._selectDeviceFn = selectDevice;
      }
    }
  }, {
    key: "cancelReadHardwareAccounts",
    value: function cancelReadHardwareAccounts() {
      this.ledger.cancelReadHardwareAccounts();
    }
  }, {
    key: "readHardwareAccounts",
    value: function () {
      var _readHardwareAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(chainId) {
        var count,
          instance,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              count = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 5;
              instance = this;
              _context5.prev = 2;
              _context5.next = 5;
              return instance.ledger.readHardwareAccounts(chainId, instance.accounts, count);
            case 5:
              _context5.next = 10;
              break;
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](2);
              console.error(_context5.t0);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[2, 7]]);
      }));
      function readHardwareAccounts(_x5) {
        return _readHardwareAccounts.apply(this, arguments);
      }
      return readHardwareAccounts;
    }()
  }, {
    key: "getDeviceName",
    value: function () {
      var _getDeviceName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.ledger.getDeviceName());
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getDeviceName() {
        return _getDeviceName.apply(this, arguments);
      }
      return getDeviceName;
    }()
  }]);
  return LedgerWallet;
}(HardwareWallet);
export default LedgerWallet;